import { useToast } from '@chakra-ui/react';
import { useEffect, useState } from 'react';

import { trpc } from '../../config/trpc';

export const useUpdateQuote = (id?: number) => {
  const { mutateAsync, isLoading, error: initialError } = trpc.updateQuote.useMutation();
  const toast = useToast();

  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (initialError) setError(initialError?.message);
    // settimeout to clear error after 5 seconds
    setTimeout(() => setError(null), 5000);
  }, [initialError]);

  const update = async (args: Parameters<typeof mutateAsync>[0]) => {
    const { warnings, quote } = await mutateAsync({ id, ...args });
    if (warnings?.length) {
      toast({
        title: 'Warning',
        description: warnings,
        duration: 5000,
        colorScheme: 'yellow',
      });
    }
    return quote;
  };

  return [update, isLoading, error] as const;
};
